var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eval-page"},[_c('div',{staticClass:"float-back-btn",on:{"click":_vm.goBack}},[_c('span',{staticClass:"back-icon"},[_vm._v("←")]),_c('span',{staticClass:"back-label"},[_vm._v("返回列表")])]),_c('div',{ref:"iframeWrap",staticClass:"iframe-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }